export default __webpack_public_path__ + "static/media/draft.908c7789.svg";